<ngb-alert [hidden]="" *ngFor="let message of messages" [dismissible]="false" [type]="'info'">
 <span style="font-size: 20px; font-weight:bold;">{{message.messageText}}</span>
</ngb-alert>